import { useMediaQuery } from '@mui/material';
import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

type ContextType = {
	sidebarVarient: 'permanent' | 'persistent' | 'temporary';
	sidebarOpen: boolean;
	sidebarPin: boolean;
	setSidebarOpen: Dispatch<SetStateAction<boolean>>;
	setSidebarPin: Dispatch<SetStateAction<boolean>>;
};

export const SidebarContext = createContext<ContextType | undefined>(undefined);

interface IProps {
	children: React.ReactNode;
}

export const SidebarProvider = ({ children }: IProps) => {
	const isSmallScreen = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

	const [sidebarOpen, setSidebarOpen] = useState(isSmallScreen || localStorage.getItem('sidebarOpen') ? false : true);
	const [sidebarPin, setSidebarPin] = useState(isSmallScreen || localStorage.getItem('sidebarOpen') ? false : true);
	const sidebarVarient = isSmallScreen ? 'temporary' : 'permanent';

	return <SidebarContext.Provider value={{ sidebarVarient, sidebarOpen, sidebarPin, setSidebarOpen, setSidebarPin }}>{children}</SidebarContext.Provider>;
};

export const useSidebar = () => {
	const sidebarContext = useContext(SidebarContext);
	if (!sidebarContext) {
		throw new Error('Can not use sidebar context outside of sidebar provider');
	}
	const { sidebarVarient, sidebarOpen, sidebarPin, setSidebarOpen, setSidebarPin } = sidebarContext;
	return { sidebarVarient, sidebarOpen, setSidebarOpen, sidebarPin, setSidebarPin };
};
